<template>
  <!------------------------------------------------->
  <!-- VIEW ----------------------------------------->
  <!------------------------------------------------->
  <v-container>
    <v-row>
      <v-col cols="12">
        <div class="headline font-weight-bold mb-4">
          {{$t("communication_by_org.title")}}
        </div>
        <v-breadcrumbs
          divider=">"
          :items="breadcrumbItems"
          class="pa-0"
        ></v-breadcrumbs>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text class="d-flex justify-space-between">
            <span class="title">
              {{$t("communication_by_org.title")}}
            </span>
            <v-btn
              color="primary"
              icon
              @click="toggleDrawerConfig(true)"
            >
              <v-icon> tune </v-icon>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!------------------------------------------------->
    <!-- Drawer --------------------------------------->
    <!------------------------------------------------->    

    <v-navigation-drawer
      :value="isOpenDrawer"
      :permanent="isOpenDrawer"
      width="1000px"
      max-width="100vw"
      right
      fixed
      temporary
      color="grey lighten-3"
      style="z-index: 11; transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1)"
    >
      <v-card min-height="100vh" color="grey lighten-3">
        <BaseToolbar
          @close="closeDrawerConfig"
          title="Informative dialog"
          type-title="icon"
          icon="edit"
          :loader-save="submitLoading"
        />
        <v-card-text
          style="overflow-y: auto; height: calc(100vh - 64px)"
        >
          <v-container class="pa-5">
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="6" md="4" lg="3">
                  <v-btn
                    color="primary"
                    block
                    @click="openDialogConfig()"
                  >
                    <v-icon left> add </v-icon>
                    {{$t('actions.add')}}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
            <v-data-table
              :headers="headers"
              :items="popups"
              
              class="elevation-1"
            >
              <template v-slot:top>
                <v-dialog v-model="dialogDelete" max-width="650px">
                  <v-card>
                    <v-card-title class="text-h5">{{
                      $t("communication_by_org.dialog.delete")
                    }}</v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete">{{
                        $t("actions.cancel")
                      }}</v-btn>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="deleteItemConfirm"
                        >OK</v-btn
                      >
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template  v-slot:item.actions="{ item }">
                <tr>
                  <v-btn icon>
                    <v-icon @click="editItem(item)" color="primary">tune</v-icon>
                  </v-btn>
                  <v-btn  icon>
                    <v-icon @click="deleteItem(item)" color="red">delete</v-icon>
                  </v-btn>
                </tr>
              </template>
              <template v-slot:item.organization_id="{ item }">
                <tr align="center">
                  <td >{{setOrganizationName(item)}}</td>
                </tr>
              </template>
              <template v-slot:item.title="{ item }">
                <tr align="center">
                  <td class="truncateTitle" >{{item.title}}</td>
                </tr>
              </template>
              <template v-slot:item.status="{ item }">
                <tr v-if="item.status==='disabled'" style="color:red;" align="center">
                  <td  >{{item.status}}</td>
                </tr>
                <tr v-else style="color:green;" align="center">
                  <td  >{{item.status}}</td>
                </tr>
              </template>
              <template v-slot:item.enabled="{ item }">
                <tr align="center">
                  <v-btn small v-if="item.status==='enabled'" block color="primary" @click="toDisable(item)">
                    {{$t("actions.disable")}}
                  </v-btn>
                  <v-btn small v-else  block color="primary" @click="toEnable(item)">
                    {{$t("actions.enable")}}
                  </v-btn>
                </tr>
              </template>
            </v-data-table>

          </v-container>
        </v-card-text>
      </v-card>

      <!------------------------------------------------->
      <!-- DIALOG TO MODIFY ----------------------------->
      <!------------------------------------------------->      

      <v-dialog
        v-model="isOpenDialogConfig"
        persistent
        :overlay="true"
        max-width="550px"
        transition="dialog-transition"
      >
        <v-card>
          <v-card-title class="pa-4">
            {{$t("communication_by_org.title")}}
          </v-card-title>
          <v-card-text class="pa-4">
            <v-form ref="form" v-model="valid" lazy-validation >
              <v-row>
                <v-col cols="12">
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="popUpConfig.title"
                    :label="$t('communication_by_org.form.title')"
                    :rules="titleRules"
                    required
                  />
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="popUpConfig.content"
                    :label="$t('communication_by_org.form.content')"
                    :rules="contentRules"
                    required
                    no-resize
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="popUpConfig.confirm"
                    :label="$t('communication_by_org.form.confirm_text')"
                    :rules="textRules"
                    required
                  />
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                  :items="availableOrganizations"
                  item-text="name"
                  item-value="id"
                  v-model="popUpConfig.organization_id"
                  label="Organization"
                  outlined
                  hide-details
                  clearable
                  :rules="organizationRules"
                  required
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn
              color="primary"
              text
              width="100px"
              @click="closeDialogConfig()"
            >
              {{ $t("actions.cancel") }}
            </v-btn>
            <v-btn :disabled="!valid" color="primary" width="100px" @click="savePopupConfig()">
              {{ $t("actions.save") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-navigation-drawer>
  </v-container>
</template>

<script>
import { organizationService } from "@/services/organization.service";
import { mapGetters, mapActions} from "vuex";
import BaseToolbar from '@/components/BaseToolbar.vue'


export default {
  name: "Organization",
  components: {
    BaseToolbar,
  },
  data() {
    return {
      titleRules: [
        (v) => !!v || "Title is required",
      ],
      contentRules: [
        (v) => !!v || "Content is required",
      ],
      textRules: [
        (v) => !!v || "Text is required",
      ],
      organizationRules: [
        (v) => !!v || "Organization is required",
      ],
      valid:true,
      dialogDelete: false,
      organizations: [],
      headers: [
        {
          text: this.$t("communication_by_org.table.title"),
          align: 'start',
          sortable: false,
          value: 'title',
        },
        { text: this.$t("communication_by_org.table.organization"), value: 'organization_id' },
        { text: 'Status', value: 'status' },
        { text: this.$t("communication_by_org.table.actions"), value: 'actions' },
        { text: this.$t("communication_by_org.table.enable"), value: 'enabled' },
      ],
      submitLoading: false,
      isOpenDrawer: false,
      breadcrumbItems: [
        {
          text: "Comunicaciones",
          disabled: false,
        },
        {
          text: "Configurar comunicaciones por organización",
          disabled: true,
          href: "",
        },
      ],
      isOpenDialogConfig: false,
      popUpConfig: {
        title: null,
        content: null,
        confirm: null,
        organization_id: null,
        status:'enabled'
      },
      defaultPopUpConfig: {
        title: null,
        content: null,
        confirm: null,
        organization_id: null,
        status:'enabled'
      },
    };
  },
  computed: {
    ...mapGetters({
      popups: "communicationByOrg/popups",
    }),
    availableOrganizations () {
      return this.organizations.map(e => {
        return {
          ...e,
          disabled: this.popups.some(item => item.organization_id == e.id)
        }
      })
    },
  },

  async created () {
    this.getAllOrganizations()
    this.readPopups()
  },

  methods: {
    ...mapActions({
      getPopups: "communicationByOrg/getPopups",
      putPopup: "communicationByOrg/putPopup",
      deletePopup: "communicationByOrg/deletePopup",
    }),

    async updatePopup() {
      await this.putPopup(this.popUpConfig)
    },
    async destroyPopup() {
      await this.deletePopup(this.popUpConfig)
    },
    async readPopups() {
      await this.getPopups()
    },

    async getAllOrganizations() {
      try {
        const response = await organizationService.getAllOrganizations();
        this.organizations = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    toggleDrawerConfig(isOpen) {
      this.isOpenDrawer = isOpen
    },
    closeDrawerConfig() {
      this.isOpenDrawer = false;
    },
    openDialogConfig() {
      this.isOpenDialogConfig = true;
    },
    closeDialogConfig() {
      this.isOpenDialogConfig = false;
      this.$refs.form.resetValidation();
      this.$nextTick(() => {
        this.popUpConfig = Object.assign({}, this.defaultPopUpConfig);
      });
    },
    savePopupConfig() {
      if (this.$refs.form.validate()) {
        this.updatePopup()
        this.closeDialogConfig()
      }
    },
    deleteItem(item) {
      this.popUpConfig = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      this.destroyPopup()
      this.closeDelete();
      this.$refs.form.resetValidation();
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.popUpConfig = Object.assign({}, this.defaultPopUpConfig);
        this.$refs.form.resetValidation();
      });
    },
    editItem(item) {
      this.popUpConfig = Object.assign({}, item);
      this.openDialogConfig()
    },
    setOrganizationName(item){
       return this.organizations.find(e => e.id == item.organization_id).name
    },
    toDisable(item){
      this.popUpConfig = Object.assign({}, item);
      this.popUpConfig.status = 'disabled'
      this.updatePopup()
      this.closeDialogConfig()
    },
    toEnable(item){
      this.popUpConfig = Object.assign({}, item);
      this.popUpConfig.status = 'enabled'
      this.updatePopup()
      this.closeDialogConfig()

    }
  },
};
</script>

<style scoped>
.truncateTitle {
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>